import type { WorkspaceMode } from "./storeTypes.ts";

interface WorkspaceVisibilityOptions {
  workspaceMode: WorkspaceMode;
  viewportVisible: boolean;
  renderVisible: boolean;
}

interface ObjectVisibilityOptions {
  workspaceMode: WorkspaceMode;
  visibility: ReadonlyMap<string, boolean>;
  renderVisibility: ReadonlyMap<string, boolean>;
  keys: readonly (string | null | undefined)[];
}

interface RenderOutputVisibilityOptions {
  visibility: ReadonlyMap<string, boolean>;
  renderVisibility: ReadonlyMap<string, boolean>;
  keys: readonly (string | null | undefined)[];
}

export function workspaceUsesRenderVisibility(
  workspaceMode: WorkspaceMode,
): boolean {
  return workspaceMode === "render" || workspaceMode === "inking";
}

export function readVisibilityFlag(
  flags: ReadonlyMap<string, boolean>,
  keys: readonly (string | null | undefined)[],
): boolean {
  for (const key of keys) {
    if (!key) continue;
    const value = flags.get(key);
    if (value !== undefined) return value;
  }
  return true;
}

export function isVisibleInWorkspace({
  workspaceMode,
  viewportVisible,
  renderVisible,
}: WorkspaceVisibilityOptions): boolean {
  if (!viewportVisible) return false;
  return !workspaceUsesRenderVisibility(workspaceMode) || renderVisible;
}

export function isObjectVisibleInWorkspace({
  workspaceMode,
  visibility,
  renderVisibility,
  keys,
}: ObjectVisibilityOptions): boolean {
  return isVisibleInWorkspace({
    workspaceMode,
    viewportVisible: readVisibilityFlag(visibility, keys),
    renderVisible: readVisibilityFlag(renderVisibility, keys),
  });
}

export function isObjectVisibleInRenderOutput({
  visibility,
  renderVisibility,
  keys,
}: RenderOutputVisibilityOptions): boolean {
  return (
    readVisibilityFlag(visibility, keys) &&
    readVisibilityFlag(renderVisibility, keys)
  );
}
